import * as React from 'react';

import { TOfferPhoto } from '../../../types/offer';
interface IUsePreviewImageProps {
  photos?: TOfferPhoto[];
}

export const usePreviewImage = (offer?: IUsePreviewImageProps): string => {
  return React.useMemo(() => {
    if (offer?.photos?.length) {
      return (offer.photos.find(p => p.isDefault) || offer.photos[0])?.miniUrl;
    }

    return '';
  }, [offer]);
};
